import { logger } from '@/features/notifications/logger'
import NotificationGuard from '@/features/notifications/notification-service-extension-shared/guards/app'
import { Notification } from '@/features/notifications/notification-service-extension-shared/types/app'
import { navigateToOrderDetail } from '@/features/orders/thunks/navigateToOrderDetail'
import { RootState } from '@/redux/store'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const handleNotificationPressAction = createAsyncThunk<
    void,
    Notification,
    { state: RootState }
>('handleNotificationPressAction', (notification, { dispatch }) => {
    if (
        NotificationGuard.isNewOrder(notification) ||
        NotificationGuard.isPostponedOrder(notification)
    ) {
        dispatch(navigateToOrderDetail({ id: notification.orderId }))

        return
    }

    logger.withMetadata({ extras: { notification } }).warn('Unknown type of notification received')
})
